import styled from 'styled-components/macro';
import { mediumHeightScreens, smallScreens } from '../../../../../../common/fontElements';
import * as colors from '../../../../../../common/colorConstants';

export const ResultCancelSubscriptionRow = styled.tr`
  flex: 1;
  color: #ffffff;
  cursor: pointer;
  background-color: ${(props) => (props.active ? '#CCEBDE' : 'white')};
  display: flex;
  border-bottom: 0.1rem solid #d8e8ef;
  align-items: center;
  & em {
    background-color: #a1b6a7;
    color: #fff;
    font-style: normal;
  }
  & td {
    padding: 20px 8px 20px 8px !important;
    vertical-align: top;
    border-top: 0 !important;
    @media (max-height: ${mediumHeightScreens}) {
      padding: 10px 8px 10px 8px !important;
    }
  }
  &:hover {
    background-color: ${(props) => (props.active ? '#CCEBDE !important' : 'white !important')};
  }
`;

export const ResultsCancelSubscriptionNameHead = styled.td`
  color: ${colors.darkGray9};
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;
